<script setup lang="ts">
import { type PropType } from "vue";
import type { UIColor } from "../../..";

defineProps({
  colorBackground: {
    type: String as PropType<UIColor>,
    required: true,
  },
});
</script>

<template>
  <div
    :class="['label', $style.container]"
    :style="{ 'background-color': `var(${colorBackground})` }"
    @click="$emit('click', $event)"
  >
    <slot name="copy" />
  </div>
</template>

<style module>
.container {
  display: inline-flex;
  flex-direction: row;
  width: fit-content;
  align-items: center;
  padding: 0rem 0.5rem;
  cursor: default;
  user-select: none;
}
</style>
